import qs from "qs";
import { getEnvVar } from "@/utils";
import { PromosOutputParams } from "@/../types/promos-types";

const VITE_MICROSERVICE_HOST = getEnvVar("VITE_MICROSERVICE_HOST");

async function fetchPromosData(
  params: PromosOutputParams,
  token: string | Error
): Promise<Response> {
  const endpoint = VITE_MICROSERVICE_HOST + "/promotion/promotions";
  const query = qs.stringify(params, { arrayFormat: "comma", skipNulls: true });

  const url = endpoint + "?" + query;

  return fetch(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
}

async function fetchDurationsData(
  gateway: string,
  destination: string,
  year_month: string,
  token: string | Error
): Promise<Response> {
  const endpoint = VITE_MICROSERVICE_HOST + "/promotion/durations";
  const params = {
    gateway,
    destination,
    year_month,
  };
  const query = qs.stringify(params, { arrayFormat: "comma", skipNulls: true });

  const url = endpoint + "?" + query;

  return fetch(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
}

export { fetchPromosData, fetchDurationsData };
